import React, { FC, Fragment } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Theme,
    useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ClientDirectoryItem from '../client-directory-item/client-directory-item.component';
import { LabClient } from 'models/client-directory';
import InfiniteScroll from 'react-infinite-scroll-component';
import { customerSettings } from 'utils/customerSettings';
import { CONSTANTS } from 'config/constants';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import useFixMissingScroll from 'utils/use-fix-missing-scroll';

type ClientDirectoryListProps = {
    filteredClients: LabClient[];
    onFetchMoreChange: () => void;
    isFiltered: boolean;
};
const ClientDirectoryList: FC<ClientDirectoryListProps> = ({
    filteredClients,
    onFetchMoreChange,
    isFiltered,
}: ClientDirectoryListProps) => {
    const { t: translate } = useTranslation(['common', 'client-directory', 'organization']);
    const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const currentOrg = currentOrgVar();
    const isPtjOrg = customerSettings.getCustomerSetting(
        currentOrg?.customerSettings,
        CONSTANTS.SETTINGS_NAMES.PTJ_ORGANIZATION,
    );

    // Fix for infinite scroll not working on some screen sizes.
    useFixMissingScroll(onFetchMoreChange, filteredClients?.length || 0);

    return (
        <Fragment>
            <InfiniteScroll
                dataLength={filteredClients.length}
                next={onFetchMoreChange}
                hasMore={!isFiltered}
                throttleTimeInMs={75}
                loader={undefined}
            >
                <TableContainer component={Paper}>
                    <Table size={!isLargeScreen ? 'small' : 'medium'}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{translate('common:NAME')}</TableCell>
                                {isPtjOrg && <TableCell>{translate('organization:CUSTOMER_NUMBER')}</TableCell>}
                                <TableCell>{translate('client-directory:ACTION_LIST')}</TableCell>
                                <TableCell>{translate('client-directory:MATERIAL_LIST')}</TableCell>
                                <TableCell>{translate('client-directory:CUSTOMER_TYPE')}</TableCell>
                                {!isMobile && <TableCell width="1"></TableCell>}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredClients?.map((client, index) => (
                                <ClientDirectoryItem key={index} client={client} isPtjOrg={isPtjOrg} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </InfiniteScroll>
        </Fragment>
    );
};

export default ClientDirectoryList;
